module.exports = __webpack_public_path__ + "static/media/delivery-man.b5d2ffae.svg";